import { render, staticRenderFns } from "./cuspreEdit.vue?vue&type=template&id=a807fc2c&scoped=true&"
import script from "./cuspreEdit.vue?vue&type=script&lang=tsx&"
export * from "./cuspreEdit.vue?vue&type=script&lang=tsx&"
import style0 from "./cuspreEdit.vue?vue&type=style&index=0&id=a807fc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a807fc2c",
  null
  
)

export default component.exports